import { apiSlice } from "../api/apiSlice";

export const supportTicketApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        createSupportTicket: builder.mutation({
            query: (ticketData) => {
                // Check if there's an attachment (FormData)
                if (ticketData instanceof FormData) {
                    return {
                        url: `/therapist/support-ticket`,
                        method: 'post',
                        body: ticketData,
                        // RTK Query will automatically handle FormData and set proper Content-Type with boundary
                    };
                } else {
                    // Regular JSON request without attachment
                    return {
                        url: `/therapist/support-ticket`,
                        method: 'post',
                        body: ticketData,
                    };
                }
            },
            invalidatesTags: ['supportTickets']
        }),
        getSupportTickets: builder.query({
            query: () => ({
                url: `/therapist/support-ticket`,
                method: 'get'
            }),
            providesTags: ['supportTickets']
        }),
    })
});

export const {
    useCreateSupportTicketMutation,
    useGetSupportTicketsQuery,
} = supportTicketApiSlice;

